import * as React from "react";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import { ConnectivityStrength } from "../../utils/hooks/useInternetConnectivityStatus";

export const Footer = () => {
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar
        position="fixed"
        color="primary"
        sx={{
          top: "auto",
          bottom: 0,
          p: "0px",
          maxHeight: "35px",
        }}
      >
        <ConnectivityStrength />
      </AppBar>
    </React.Fragment>
  );
};
